import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceCustomFieldCleanupRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-custom-field-cleanup',
	path: '/jira/settings/system/performance/metrics/customfield/cleanup',
};
